<template>
  <div id="realdata">
    <!-- 数据概览 -->
    <div class="top" v-if="!showinfo">
      <div class="box" v-for="(item, index) in boxlist" :key="index">
        <div class="box_top">{{ item.info }}</div>
        <div class="box_bt">
          <span v-if="index != 1">{{ item.num }}</span>
          <span v-if="index == 1">{{ item.num1 }}/</span>
          <span v-if="index == 1">{{ item.num2 }}</span>
        </div>
        <img src="../../assets/img/logo2.png" alt="" />
      </div>
    </div>
    <div class="content" v-if="!showinfo">
      <div class="content_top">
        <div class="search">
          <diy_search :searchData="searchList" @initTableData="initTableData"></diy_search>
        </div>
        <div class="search_left">
          <!-- <div class="btn">
            <img src="../../assets/img/fs.png" alt="" />
            <span @click="dx">发送通知</span>
          </div> -->
          <div class="btn">
            <el-tooltip class="tooltip" effect="dark" content="审核资料包导出" placement="top">
              <div @click="exportbao" class="zip"></div>
            </el-tooltip>
            <!-- <img src="../../assets/img/dc.png" alt="" />
            <span @click="exportbao">审核资料包导出</span> -->
          </div>
          <div class="btn">
            <!-- <img src="../../assets/img/dc.png" alt="" />
            <span @click="exportExcel">Excel导出</span> -->
            <el-tooltip class="tooltip" effect="dark" content="Excel导出" placement="top">
              <!-- <el-button @click="exportExcel" circle></el-button> -->
              <div @click="exportExcel" class="bg"></div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="content_content">
        <div class="tableData">
          <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" height="100%"
            :header-cell-style="{
      background: ' rgba(240, 240, 240, 1)',
      color: '#000000',
    }" :default-sort="sortConfig" @sort-change="sortChange" @selection-change="handleSelectionChange">
            <el-table-column width="55" type="selection" fixed>
            </el-table-column>
            <template><el-table-column v-for="(item, index) in tableMenu" :property="item.key" :key="index"
                :label="item.name" :show-overflow-tooltip="item.key != 'isSelect'" :sortable="item.sortable"
                :min-width="item.width" style="background-color: #eee">
              </el-table-column>
            </template>

            <el-table-column prop="status" label="审核状态" width="80" fixed="right">
            </el-table-column>
            <el-table-column label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button @click="handleClick('view', scope.row)" type="text" size="small">查看详情</el-button>
                <el-button @click="handleClick('revokeCheck', scope.row)" type="text" size="small">撤销审核</el-button>
                <el-button @click="handleClick('delEnroll', scope.row)" type="text" size="small"
                  style="color: red;">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page.sync="pageData.currentPage" :page-size="pageData.pageSize"
            layout="total,sizes, prev, pager, next,jumper" :total="pageData.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  查看个人信息 -->
    <div class="showinfo" v-if="showinfo">
      <diy_infomation v-if="realData.flag" :infomationData="realData" @ButtonClick="ButtonClick" @btnClick="btnClick">
      </diy_infomation>
    </div>
    <!-- 确认是否删除学生信息的弹窗 -->
    <el-dialog title="删除操作" :visible.sync="dialogVisible" class="delEnroll_dialog" width="422px">
      <span class="delEnroll" style="margin-right: 136px;">请确认是否删除该名学生的信息!</span>
      <el-switch v-model="valuedelEnroll" active-color="#13ce66">
      </el-switch>
      <span slot="footer" class="dialog-footer">
        <el-button class="btns" @click="dialogVisible = false">取 消</el-button>
        <el-button class="btns" type="primary" @click="makedelEnroll" :disabled="!valuedelEnroll">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as realdata from "./js/realdata.js";

export default {
  data() {
    return {
      showinfo: false, //控制表格的显示或者隐藏
      configList: {
        // 所有配置项数组集
        schoolList: [], //学校
        professionList: [], // 专业
      },
      searchList: [],
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 20, // 每页条数
      },
      sortConfig: {
        prop: "check_time",
        order: "descending",
      },
      tableMenu: realdata.getAttributeMenu(),
      tableData: [],
      boxlist: [
        {
          info: "报名人数",
          num: "1349",
        },
        {
          info: "通过/不通过人数",
          num1: "82",
          num2: "82",
        },
        {
          info: "待审核人数",
          num: "1349",
        },
      ],
      /* 查看个人信息 */
      realData: {
        flag: true,
        // activebtn: 0,
        blist: [
          {
            name: "返回列表",
            active: "realData",
            icon: "el-icon-d-arrow-left",
          },
        ],
        data: realdata.getpeopleinfo(),
        buttonArray: [
          { name: "审核资料包导出", active: "dataExport", isNull: true },
        ],
      },
      multipleSelection: [],
      tempTableItem: {},
      //确认是否删除学生信息的弹窗
      dialogVisible: false,
      valuedelEnroll: false,
    };
  },
  methods: {
    //实时数据展示(先只展示当年的数据)
    showData() {
      this.$request("post", "/enrollInfo/showData", null, (data) => {
        console.log("实时数据展示", data);
        this.boxlist[0].num = data.allNum;
        this.boxlist[1].num1 = data.successNum;
        this.boxlist[1].num2 = data.errNum;
        this.boxlist[2].num = data.waitNum;
        this.getLabelList2();
      });
    },
    /**
     * 获取报考专业
     */
    getLabelList2() {
      let requestData = {
        type: "profession",
      };
      this.configList.professionList = [];
      this.$request("post", "/label/getLabelList", requestData, (data) => {
        data.forEach((element) => {
          let dd = {
            label: element.content,
            value: element.content,
          };
          this.configList.professionList.push(dd);
        });
        this.getAllSchool();
      });
    },
    //获取学校列表
    getAllSchool() {
      this.$request("post", "/enrollInfo/getAllSchool", null, (data) => {
        console.log("获取学校列表", data);
        let arr = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let obj = {
            label: element,
            value: element,
          };
          arr.push(obj);
          this.configList.schoolList = arr;
        }
        this.searchList = realdata.getRoomAttributSearchData(this.configList);
        this.initTableData();
      });
    },

    //获取表格数据
    initTableData() {
      let requestData = {
        search: this.searchList[0].value,
        school: this.searchList[1].value,
        status: this.searchList[2].value,
        readyProfession: this.searchList[3].value,
        specialFlag: this.searchList[4].value,
        sortProp: this.sortConfig.prop, //排序字段
        sortOrder: this.sortConfig.order, //排序方式
        pageSize: this.pageData.pageSize,
        currentPage: this.pageData.currentPage,
        year: this.searchList[5].value
      };
      this.$request(
        "post",
        "/enrollInfo/getHistoryList",
        requestData,
        (data) => {
          console.log("获取表格数据", data);
          this.tableData = data.tableData;
          this.pageData.total = data.total;
        }
      );
    },

    //返回实时数据c
    ButtonClick(active, item) {
      switch (active) {
        case "realData":
          console.log("返回实时数据");
          this.showinfo = false;
          break;

        default:
          break;
      }
    },

    btnClick(active, item) {
      switch (active) {
        //查看个人信息是的导出个人资料包
        case "dataExport":
          console.log("查看个人信息是的导出个人资料包", this.tempTableItem);
          window.open(
            this.$baseurl +
            "/enrollInfo/reportZipInfo/" +
            this.tempTableItem.id,
            "_blank"
          );
          break;

        default:
          break;
      }
    },

    handleClick(active, item) {
      console.log("item", item);
      let requestData = {};
      switch (active) {
        //查看
        case "view":
          this.tempTableItem = JSON.parse(JSON.stringify(item)); //将需要查看的学生信息临时存储起来
          this.realData.data = realdata.getpeopleinfo();
          this.$request(
            "post",
            "/enrollInfo/getEnroll",
            {
              enrollId: item.id,
              flag: "2",
            },
            (data) => {
              let icons = ["png", "jpeg", "jpg"];
              this.realData.data.forEach((element) => {
                if (
                  element.key == "statusCheckFile" &&
                  (data.graduating == "2" || data.graduating == 2)
                ) {
                  element.value = data.diplomaFile;
                  element.key = "diplomaFile";
                  element.name = "中职毕业证原件";
                } else if (element.key == "status") {
                  // 单独处理审核结果
                  element.value =
                    data.status == "2" || data.status == 2
                      ? "已通过"
                      : "不通过";
                } else if (element.key == "refuseReason") {
                  // 单独处理不通过原因
                  element.value =
                    data.status == "2" || data.status == 2
                      ? "-"
                      : data[element.key];
                } else if (element.key == "contact" || element.value == null) {
                  element.value = '--'
                }
                else if (element.key == "graduating") {
                  element.value =
                    data[element.key] == "1" ? "应届生" : "往届生";
                } else {
                  element.value = data[element.key];
                }
                if (element.type == "file" && data[element.key].length > 0) {
                  let ii = data[element.key][0].path.split(".");
                  // 文件若为图片,以缩略图展示
                  console.log("文件后缀", ii[ii.length - 1]);
                  if (ii.length > 0 && icons.includes(ii[ii.length - 1])) {
                    element.type = "icon";
                  } else {
                    element.type = "file";
                  }
                }
                if (
                  element.type == "fileOrIcon" &&
                  data[element.key].length > 0
                ) {
                  // 文件或图片展示
                  data[element.key].forEach((file) => {
                    let ii = file.path.split(".");
                    if (ii.length > 0 && icons.includes(ii[ii.length - 1])) {
                      // 如果这一个附件为图片,给这条附件添加icon属性
                      this.$set(file, "flag", "icon");
                    } else {
                      // 否则为文件,添加file属性
                      this.$set(file, "flag", "file");
                    }
                  });
                }
              });

              this.realData.flag = true;
              this.showinfo = true;
            }
          );

          break;
        case "revokeCheck":
          // this.tempTableItem = JSON.parse(JSON.stringify(item)); //将需要查看的学生信息临时存储起来
          this.$confirm("此操作将会撤销对这名学生的审核, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/enrollInfo/revokeCheck",
                {
                  id: item.id,
                },
                (data) => {
                  this.$message({
                    message: "撤销审核成功!",
                    type: "success",
                    duration: 1000,
                  });
                  this.initTableData();
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消成功",
              });
            });
          break;
        // 删除
        case "delEnroll":
          this.valuedelEnroll = false;
          this.tempTableItem = JSON.parse(JSON.stringify(item)); //将需要删除的学生信息临时存储起来
          this.dialogVisible = true;

        default:
          break;
      }
    },

    //确认删除信息
    makedelEnroll() {
      this.$request(
        "post",
        "/enrollInfo/delEnroll",
        {
          id: this.tempTableItem.id
        },
        (data) => {
          this.dialogVisible = false;
          this.$message({
            message: "删除成功!",
            type: "success",
            duration: 1000,
          });
          this.initTableData();
        }
      );
    },

    // 批量发送短信
    dx() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先勾选要发送的账号信息!",
          type: "error",
          duration: 1000,
        });
        return;
      }
      let arr = [];
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const element = this.multipleSelection[index];
        arr.push(element.id);
      }
      console.log("批量发送勾选是以上所有数据", this.multipleSelection);
      this.$confirm("此操作将会给勾选的账号发送短信通知, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request("post", "/enrollInfo/sendNotice", arr, (data) => {
            //批量发送
            this.multipleSelection = [];
            this.$message({
              message: "短信发送成功!",
              type: "success",
              duration: 1000,
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消短信发送",
          });
        });
    },

    //以Excel导出
    exportExcel() {
      //1.选择导出
      if (this.multipleSelection.length == 0) {
        let value = this.searchList[0].value;
        let requestData = {
          flag: "2",
          search: value,
          sortProp: this.sortConfig.prop, //排序字段
          sortOrder: this.sortConfig.order, //排序方式
          school: this.searchList[1].value,
          status: this.searchList[2].value,
          readyProfession: this.searchList[3].value,
          specialFlag: this.searchList[4].value,
          year: this.searchList[5].value
        };
        this.$confirm("此操作是导出查询状态下的信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$requestForReport(
              "post",
              "/enrollInfo/reportList",
              requestData,
              (data) => {
                console.log("成功", data);
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = `审核资料.xlsx`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "审核资料导出成功!",
                  duration: 1000,
                });
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消导出",
            });
          });
      } else {
        let ids = [];
        for (let index = 0; index < this.multipleSelection.length; index++) {
          const element = this.multipleSelection[index];
          ids.push(element.id);
        }
        let requestData = {
          flag: "1",
          ids: ids,
        };
        this.$confirm("此操作是导出勾选的信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$requestForReport(
              "post",
              "/enrollInfo/reportList",
              requestData,
              (data) => {
                console.log("成功", data);
                let blob = new Blob([data], {
                  type: "application/force-download",
                }); // Blob 对象表示一个不可变、原始数据的类文件对象
                console.log(blob);
                let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
                fileReader.readAsDataURL(blob);
                //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
                fileReader.onload = (e) => {
                  let a = document.createElement("a");
                  a.download = `审核资料.xlsx`;
                  a.href = e.target.result;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                };

                this.$message({
                  type: "success",
                  message: "审核资料导出成功!",
                  duration: 1000,
                });
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消导出",
              duration: 1000,
            });
          });
      }
    },

    //以审核资料包导出
    exportbao() {
      let requestData = {};
      if (this.multipleSelection.length == 0) {
        this.$message.error("请先勾选要导出的资料包!");
        return;
      }
      for (let index = 0; index < this.multipleSelection.length; index++) {
        const element = this.multipleSelection[index];
        window.open(
          this.$baseurl + "/enrollInfo/reportZipInfo/" + element.id,
          "_blank"
        );
      }
    },
    //表格勾选功能
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 页码选择器改变事件
     * val:每页条数
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageData.pageSize = val;
      this.initTableData();
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.initTableData();
    },
    sortChange(e) {
      this.sortConfig.prop = "check_time";
      this.sortConfig.order = e.order;
      this.initTableData();
    },
  },
  mounted() {
    this.showData(); //实时数据展示
    // this.getAllSchool(); //实时数据展示
  },
};
</script>

<style lang="less" scoped>
#realdata {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .top {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .box {
      width: 0;
      flex: 1;
      height: 160px;
      box-sizing: border-box;
      padding: 30px 0 9px 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);

      .box_top {
        width: 100%;
        display: flex;
        justify-items: center;
        font-size: 24px;
        font-weight: 400;
        letter-spacing: 2px;
        color: rgba(0, 0, 0, 1);
      }

      .box_bt {
        height: 68px;
        display: flex;
        align-items: center;
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 3px;
        color: rgba(0, 118, 252, 1);
      }

      >img {
        width: 250px;
        height: 50px;
        opacity: 0.5;
      }

      &:nth-child(2) {
        margin: 0 40px;
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    height: 0;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    padding: 5px 32px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;

    .content_top {
      width: 100%;
      height: 40px;
      display: flex;
      box-sizing: border-box;
      margin-bottom: 10px;

      .search {
        height: 100%;
        width: auto;
      }

      .search_left {
        height: 100%;
        width: 0;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .btn {
          box-sizing: border-box;
          border-radius: 3px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 0.3s;

          &:hover {
            cursor: pointer;
          }

          >img {
            width: 16px;
            height: 16px;
          }

          .zip {
            background: url('../../assets/img/zip.png') no-repeat;
            height: 35px;
            width: 35px;
            background-size: 100% auto;
          }

          .bg {
            background: url('../../assets/img/bg.png') no-repeat;
            height: 35px;
            width: 35px;
            background-size: 100% auto;
          }

          >span {
            margin-left: 5px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }

          &:nth-child(2) {
            margin: 0 10px;
          }
        }
      }
    }

    .content_content {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;
      flex-direction: column;

      >.tableData {
        width: 100%;
        height: 0;
        flex: 1;

        .dir {
          display: flex;

          >.dit {
            width: auto;
            height: auto;
            padding: 2px 8px;
            margin: 0 4px;
            box-sizing: border-box;
            background-color: #00a0fc23;
            font-size: 13px;
            border-radius: 4px;

            &:nth-child(1) {
              margin-left: 0;
            }
          }
        }

        .dut {
          font-size: 13px;
          color: #31b3ffe7;
          transition: 0.3s;

          &:hover {
            cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
    }
  }

  .showinfo {
    width: 100%;
    height: 100%;
  }

  .tooltip {
    margin: 4px;
  }

  /deep/.el-dialog {
    border-radius: 4px;
    margin-top: 6.5vh !important;
  }

  .delEnroll {
    line-height: 18px;
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }

  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/.el-dialog__header {
    padding: 15px 15px 10px;
    text-align: left;
    color: #303133;
    font-size: 18px;
    font-family: 'SimHei';

  }

  /deep/ .el-dialog__body {
    padding: 10px 15px !important;
    color: #606266;
    font-size: 14px;
    text-align: left;
    font-family: 'SimHei';

  }

  .btns {
    padding: 9px 15px;
  }

  /deep/ .el-dialog__footer {
    padding: 10px 20px 10px
  }
}
</style>
